<fui-filter-fascia [disabled]="disabled" [focussed]="focussed" [hovered]="hovered" [tabindex]="tabindex">
    <fui-fixtures>
        <fui-fixture>
            <fui-icon [icon]="'globe'"></fui-icon>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="true" #input (focus)="onFocus($event)"
                       [placeholder]="label" [tabindex]="tabindex" type="text">
            </fui-input-dom>
        </fui-spanning-fixture>
    </fui-fixtures>
</fui-filter-fascia>
